/* ============================================================
   AM2T — product-recommendations.js
   Loaded by sections/product-recommendations.liquid only.
   - Carousel arrows / dots (carousel mode)
   - Quick add (JSON add through AM2T.cart, so the pack guard sees it)
   ============================================================ */

(() => {
  'use strict';

  const setupCarousel = (wrap) => {
    if (wrap.dataset.ready === 'true') return;
    wrap.dataset.ready = 'true';

    const list = wrap.querySelector('[data-carousel-track]');
    const cards = wrap.querySelectorAll('.complete-the-kit__row--card');
    const prevBtn = wrap.querySelector('[data-carousel-prev]');
    const nextBtn = wrap.querySelector('[data-carousel-next]');
    const dotsContainer = wrap.querySelector('[data-carousel-dots]');
    if (!list || cards.length === 0) return;

    const cardStep = () => {
      const first = cards[0];
      if (!first) return 0;
      const style = getComputedStyle(list);
      const gap = parseFloat(style.columnGap || style.gap || '16') || 0;
      return first.offsetWidth + gap;
    };

    if (dotsContainer) {
      cards.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'complete-the-kit__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', window.AM2T.t('carousel_go_to', { index: i + 1 }));
        if (i === 0) dot.classList.add('is-active');
        dot.addEventListener('click', () => list.scrollTo({ left: i * cardStep(), behavior: 'smooth' }));
        dotsContainer.appendChild(dot);
      });
    }

    const update = () => {
      const step = cardStep();
      if (dotsContainer && step) {
        const idx = Math.round(list.scrollLeft / step);
        dotsContainer.querySelectorAll('.complete-the-kit__dot').forEach((d, i) => {
          d.classList.toggle('is-active', i === idx);
        });
      }
      const max = list.scrollWidth - list.clientWidth;
      if (prevBtn) prevBtn.disabled = list.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = list.scrollLeft >= max - 1;
    };

    list.addEventListener('scroll', update, { passive: true });
    if (prevBtn) prevBtn.addEventListener('click', () => list.scrollBy({ left: -cardStep(), behavior: 'smooth' }));
    if (nextBtn) nextBtn.addEventListener('click', () => list.scrollBy({ left: cardStep(), behavior: 'smooth' }));
    update();
  };

  const setupQuickAdd = (form) => {
    if (form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (form.dataset.pending === '1') return;
      form.dataset.pending = '1';

      const btn = form.querySelector('button');
      const label = btn.querySelector('[data-add-label]');
      const original = label.textContent;
      const labels = {
        adding: form.dataset.labelAdding || window.AM2T.t('adding'),
        added: form.dataset.labelAdded || window.AM2T.t('added'),
        error: form.dataset.labelError || window.AM2T.t('try_again')
      };

      btn.classList.add('is-loading');
      label.textContent = labels.adding;

      try {
        const id = parseInt(form.querySelector('[name="id"]').value, 10);
        const cart = await window.AM2T.cart.add([{ id, quantity: 1 }]);
        window.AM2T.publishCart(cart, 'product-recommendations');

        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        label.textContent = labels.added;
        setTimeout(() => {
          btn.classList.remove('is-added');
          label.textContent = original;
          delete form.dataset.pending;
        }, 1200);
      } catch (err) {
        console.warn('[AM2T] quick-add failed', err);
        btn.classList.remove('is-loading');
        label.textContent = labels.error;
        setTimeout(() => {
          label.textContent = original;
          delete form.dataset.pending;
        }, 2000);
      }
    });
  };

  window.AM2T.onSection((root) => {
    root.querySelectorAll('[data-carousel]').forEach(setupCarousel);
    root.querySelectorAll('[data-quick-add]').forEach(setupQuickAdd);
  });
})();
